import { IAmendment, IBaseResponseData } from '../index.js'

/**
 * This interface defines the object that is returned by the Congress API when
 * you request a list of amendments from the `/amendment` endpoint.
 */
export interface IAmendmentsResponse extends IBaseResponseData {
  amendments: IAmendment[]
}
